// CartItem.js
import React, { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import zone_image from "../../../assets/svgs/zone_image.svg";
import quantity_image from "../../../assets/svgs/quantity_image.svg";
import { cartItemStyle as itemStyle } from "./cartInfo.tailwind";
import { cartInfoStyle as styles } from "./cartInfo.tailwind";
import { zoneImages } from "../../../lib/constants/globalConstant";
import ConfirmRemoveItemModal from "../../shared/Modals/ConfirmRemoveItemModal/ConfirmRemoveItemModal";
import TokenDetailsTable from "./TokenDetailsTable"; // Import the new component

// main cart item
const CartItem = ({ item, isExpandedDefault }) => {
  const zoneImage = zoneImages[item?.zoneCategoryName]; // to fetch the zone image based on zoneCategoryName Zone Platinum, Gold, Silver, etc.
  const zoneNames = item?.zones?.map((zone) => zone?.zoneName).join(", "); // concat all zone names for product description

  const [isExpanded, setIsExpanded] = useState(isExpandedDefault || false); // to expand and collapse the cart-sub item based on the zoneCategoryName
  const [isDeleteItemModalOpen, setIsDeleteModalOpen] = useState(false); // delete-item modal state
  const [selectedTokenId, setSelectedTokenId] = useState(null); // selected token which

  // modal open
  const handleOpenModal = (tokenId) => {
    setSelectedTokenId(tokenId);
    setIsDeleteModalOpen(true);
  };

  // modal close
  const handleCloseModal = () => {
    setIsDeleteModalOpen(false);
  };

  // toggle(to expand sub-table for each cart-item)
  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  /**
   * Adds quantity and adjusted price to each token in zones based on purchase type:
   * - If purchaseType is "1" (entire season), price remains as tokenPrice.
   * - If "2" (per match), price is tokenPrice multiplied by match quantity.
   * Returns a flattened array of tokens, each with original data, zone name, 
   * match quantity, and adjusted price.
   */
  const calculateTokenDetails = (zones) => {
    return zones?.map((zone) => {
        return zone?.tokens?.map((token) => {
          const quantity = token?.matchIds && token?.matchIds.length;
          let adjustedTokenPrice;
          if (token?.purchaseType === "1") {
            // "1" means for Entire Season
            // If purchaseType = 1, return the same token price
            adjustedTokenPrice = token?.tokenPrice;
          } else if (token?.purchaseType === "2") {
            // "2" means for each Match
            // If purchaseType = 2, multiply the price by the quantity
            adjustedTokenPrice = token?.tokenPrice * quantity;
          }

          return {
            ...token,
            zoneName: zone?.zoneName,
            quantity,
            adjustedTokenPrice,
          };
        });
      })
      .flat();
  };

  // calculate total price of all tokens in each zoneCategory
  const calculateTotalPrice = () => {
    const tokenDetails = calculateTokenDetails(item?.zones);
    // Sum all adjustedTokenPrice values
    return tokenDetails?.reduce(
      (total, tokenDetail) => total + tokenDetail?.adjustedTokenPrice,
      0
    );
  };

  const tokenDetails = calculateTokenDetails(item?.zones); // All Token items by zoneCategory
  const totalPrice = calculateTotalPrice(); // Total Sum price by ZoneCategory

  return (
    <>
      {/* Main table row */}
      <div className={itemStyle.item_container} style={{ gridTemplateColumns: "auto 70% 10%" }}>
        {/* <div className={itemStyle.product_container}> */}
          {/* Token Image */}
          <div className={itemStyle.token_container}>
            <img src={zoneImage} alt={item?.zoneCategoryName} className={itemStyle.token_image}/>
             
          </div>
        {/* </div> */}

        {/* Tokens Info */}
        <div className={itemStyle.product_info}>
          {/* Zone Category Name */}
          <span className={styles.values_text}>{item?.zoneCategoryName}</span>
          <div className={itemStyle.zone_and_quantity_container} onClick={handleToggle}>

          {/* ZoneDetails which includes zone name in which tokens are added to cart */}
            <div className={itemStyle.zone_container}>
              {/* Zone Image */}
              <div className="zone-box">
                <img src={zone_image} alt={item?.zoneCategoryName} className={styles.zone_image}/>
              </div>

              {/* Zone Name */}
              <div className={itemStyle.description_container}>
                <span className="zone-infobox">Zone</span>
                <span className={itemStyle.item_description}>{zoneNames}</span>
              </div>
            </div>

            {/* Quantity Details*/}    
            <div>
              <div className={itemStyle.zone_container}>
                <div className="zone-box">
                  <img
                    src={quantity_image}
                    alt={item?.zoneCategoryName}
                    className={styles.zone_image}
                  />
                </div>
                {/* Token Quantity */}
                <div className={itemStyle.description_container}>
                  <span className="zone-infobox">Quantity</span>
                  <span className={itemStyle.quantity_text}>
                    {item?.tokenQuantity}
                  </span>
                </div>
                
              {/* Button to handle toggle of the TokenDetailsTable */}
              <button className={itemStyle.cancel_button}>
                {isExpanded ? ( <ExpandLessIcon htmlColor="#fff" sx={{ fontSize: "22px" }} />)
                : (
                  <ExpandMoreIcon htmlColor="#fff" sx={{ fontSize: "22px" }} />
                )}
              </button>
              </div>
            </div>
          </div>
          {/* Collapsible section, tokenDetails is passed to the TokenDetailsTable component displaying the details of each token */}
          {isExpanded && (
            <TokenDetailsTable
              tokenDetails={tokenDetails}
              handleOpenModal={handleOpenModal}
            />
          )}
        </div>

        <div className={itemStyle.item_price}>
          <div className="text-left">
            {/* Total Price */}
            <div className={styles.total_value_text}>{`$ ${totalPrice}`}</div>
            <div className={`${itemStyle.item_description} !text-[13px]`}>{item?.price}</div>
          </div>
        </div>
      </div>

      <ConfirmRemoveItemModal
        isOpen={isDeleteItemModalOpen}
        onClose={handleCloseModal}
        selectedTokenId={selectedTokenId}
      />
    </>
  );
};

export default CartItem;
